import { render, staticRenderFns } from "./quesAnswer.vue?vue&type=template&id=0be5b8cd&scoped=true"
import script from "./quesAnswer.vue?vue&type=script&lang=js"
export * from "./quesAnswer.vue?vue&type=script&lang=js"
import style0 from "./quesAnswer.vue?vue&type=style&index=0&id=0be5b8cd&prod&lang=less&scoped=true"
import style1 from "./quesAnswer.vue?vue&type=style&index=1&id=0be5b8cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5b8cd",
  null
  
)

export default component.exports